import React from 'react';
import './Team.css'
import Fariha from '../../img/fariha.JPG'
import Mitu from '../../img/mitu (1).jpg'
import Miha from '../../img/miha.jfif'
import { Fade } from 'react-reveal';
const Team = () => {
    return (
        <Fade bottom duration={1000} distance="20px">
            <div style={{marginTop:'0px'}} className="main ">
            <h1 className="experience-heading">Some People Are Work With Me</h1>
               
                    <div class="row">
                        <div class="team-item">
                            <img src={Miha} alt="" />
                            <h3>Shojib Miha <span>SEO Expert</span></h3>
                        
                            <div class="social-links">
                                {/* <a href="#"><i class="fab fa-facebook-f"></i></a>
                                <a href="#"><i class="fab fa-twitter"></i></a>
                                <a href="#"><i class="fab fa-instagram"></i></a>
                                <a href="#"><i class="fab fa-linkedin-in"></i></a> */}

                            </div>
                        </div>
                        <div class="team-item">
                            <img src={Fariha} alt="" />
                            <h3>Fariha Zakir <span>Graphic Designer</span></h3>
                            <div class="social-links">
                                {/* <a href="#"><i class="fab fa-facebook-f"></i></a>
                                <a href="#"><i class="fab fa-twitter"></i></a>
                                <a href="#"><i class="fab fa-instagram"></i></a>
                                <a href="#"><i class="fab fa-linkedin-in"></i></a> */}
                            </div>
                        </div>
                        <div class="team-item">
                            <img src={Mitu} alt="" />
                            <h3>Marzia  Mitu <span>Graphic  Designer</span></h3>
                            <div class="social-links">
                                {/* <a href="https://www.facebook.com/profile.php?id=100024935673616"><i class="fab fa-facebook-f"></i></a>
                                <a href="#"><i class="fab fa-twitter"></i></a>
                                <a href="#"><i class="fab fa-instagram"></i></a>
                                <a href="#"><i class="fab fa-linkedin-in"></i></a> */}
                            </div>
                        </div>
                    </div>
                
            </div>
        </Fade>
    );
};

export default Team;